import { create } from "zustand";

export const useGeneralAppStore = create((set) => ({
  modals: [],
  loads: [],

  handlerModal: ({ modal, modalName }) => {
    if (modal) {
      set((state) => ({
        modals: [...state.modals, modalName],
      }));
    } else {
      set((state) => ({
        modals: state.modals.filter((mod) => mod != modalName),
      }));
    }
  },

  handlerLoading: ({ loading, loadName }) => {
    if (loading) {
      set((state) => ({
        loads: [...state.loads, loadName],
      }));
    } else {
      set((state) => ({
        loads: state.loads.filter((lo) => lo != loadName),
      }));
    }
  },
}));
